/**
 * Import react libraries.
 */
import * as React from 'react';
import { SystemIcons } from '../icons';
import styled from 'styled-components';
import { CommonInteractionStyling } from '../common';
import { COLORS } from '../styles';

export interface DatepickerFieldHeaderParams {
  date: Date;
  changeYear(year: number): void;
  changeMonth(month: number): void;
  customHeaderCount: number;
  decreaseMonth(): void;
  increaseMonth(): void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  decreaseYear(): void;
  increaseYear(): void;
  prevYearButtonDisabled: boolean;
  nextYearButtonDisabled: boolean;
  yearPickerMode: boolean;
  setYearPickerMode(val: boolean): void;
  setActiveMonthPage(val: number): void;
}

const HeaderLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  cursor: pointer;

  button {
    background: transparent;
    padding: 0px;
    width: auto;
  }

  svg {
    color: ${COLORS.neutral_600};
  }

  ${CommonInteractionStyling}

  &:hover {
    div {
      color: ${COLORS.primary_600} !important;
    }
    svg {
      color: ${COLORS.primary_600};
    }
  }

  &:active {
    div {
      color: ${COLORS.primary_600} !important;
    }
    svg {
      color: ${COLORS.primary_600};
    }
  }
`;

export const DatepickerFieldHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  setYearPickerMode,
  yearPickerMode,
  setActiveMonthPage,
}: DatepickerFieldHeaderParams) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const handleDecreaseMonth = () => {
    let previousMonth = date.getMonth() - 1;
    if (previousMonth < 0) previousMonth = months.length - 1;
    setActiveMonthPage(previousMonth);
    decreaseMonth();
  };

  const handleIncreaseMonth = () => {
    let nextMonth = date.getMonth() + 1;
    if (nextMonth >= months.length - 1) nextMonth = 0;
    setActiveMonthPage(nextMonth);
    increaseMonth();
  };

  React.useEffect(() => {
    setActiveMonthPage(date.getMonth());
  }, [date]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}>
        {!yearPickerMode && (
          <button type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" onClick={handleDecreaseMonth} disabled={prevMonthButtonDisabled}>
          </button>
        )}
        <HeaderLabelContainer onClick={() => setYearPickerMode(!yearPickerMode)}>
          <div className="react-datepicker__current-month">{`${months[date.getMonth()]} ${date.getFullYear()}`}</div>
          {yearPickerMode ? <SystemIcons.ArrowDropUp size="24px" /> : <SystemIcons.ArrowDropDown size="24px" />}
        </HeaderLabelContainer>
        {!yearPickerMode && (
          <button type="button" className="react-datepicker__navigation react-datepicker__navigation--next" onClick={handleIncreaseMonth} disabled={nextMonthButtonDisabled}>
          </button>
        )}
      </div>
    </>
  );
};
